import { Button, UnderlineHeading, IconQuestion } from '@tracklib/kit'
import styles from './faqblock.css'

type QuestionProps = {
  question: string
  answer: string
}

export const Question = ({ question, answer }: QuestionProps): JSX.Element => (
  <div className={styles.item}>
    <div className={styles.question}>
      <div className={styles.questionTopRow}>
        <div className={styles.iconWrapper}>
          <IconQuestion width="100%" height="100%" />
        </div>
        <span className={styles.questionText}>{question}</span>
      </div>
      <span className={styles.answerText}>{answer}</span>
    </div>
  </div>
)

type FaqBlockProps = {
  value: {
    questions: Array<QuestionProps>
  }
}

const FaqBlock = (props: FaqBlockProps): JSX.Element => {
  const {
    value: { questions },
  } = props
  const items = [
    <div className={styles.item} key="0">
      <UnderlineHeading>FAQ</UnderlineHeading>
      <Button className={styles.downloadButton}>Download the terms</Button>
    </div>,
    ...questions.map((question, index) => <Question question={question.question} answer={question.answer} key={String(index + 1)} />),
  ]
  return (
    <div className={styles.background}>
      <div className={styles.wrapper}>{items}</div>
    </div>
  )
}

export default FaqBlock
